import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import {
    LinearProgress,
    Grid,
    Typography
} from '@material-ui/core';

import {
    PageHeader
} from '../../common';

// import {
// } from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../contexts/NavContext';

import GetAppIcon from '@material-ui/icons/GetApp'
import ErrorIcon from '@material-ui/icons/Error'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        width: '200px',
        height: '200px'
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getExportInfoAsync
    } = useContext(PageContext);

    const {
        exportInfo,
        notAvailable
    } = state;

    const { token } = useParams();
    useEffect(() => {
        setPageIsReady(false);
        if (token) {
            getExportInfoAsync(decodeURI(token));
        }
    }, [token]);

    useEffect(() => {
        if (exportInfo) {
            setPageIsReady(true);
            if (exportInfo.downloadUrl) {
                const link = document.createElement('a');
                link.href = exportInfo.downloadUrl;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }, [exportInfo]);

    return (
        <>
            {pageIsReady ?
                <div className={classes.root}>
                    <Typography align="center" variant="h2">
                        {exportInfo ? "Your export is ready" : "Something went bad"}
                    </Typography>
                    <br />
                    <Typography align="center" variant="body1">
                        {exportInfo ?
                            <>
                                Download export for table <strong>{exportInfo.tableName}</strong> should start shortly, if not please click&nbsp;
                                <a href={exportInfo.downloadUrl}>here</a>
                            </>
                            :
                            "We were unable to process your download request, try later"
                        }
                    </Typography>
                    <br />
                    {exportInfo ?
                        <GetAppIcon className={classes.image} />
                        :
                        <ErrorIcon className={classes.image} />
                    }
                </div>
                :
                <LinearProgress />
            }
        </>
    );
}

export const DownloadExportPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}